import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { RelevantOpportunitiesForVolunteerList } from "./RelevantOpportunitiesForVolunteerList";

type Props = {
  open: boolean;
  onClose: () => void;
  userId: string;
  userName: string;
  associationId: string;
  organizationId: string;
  excludeOpportunityId?: string;
  hasVolunteerCoordinates?: boolean;
};

export function RelevantOpportunitiesForVolunteerDialog({
  open,
  onClose,
  userId,
  userName,
  associationId,
  organizationId,
  excludeOpportunityId,
  hasVolunteerCoordinates,
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { maxHeight: "85vh" } }}
    >
      <DialogTitle sx={{ pr: 6 }}>
        משימות מתאימות ל-{userName || "מתנדב/ת"}
        <IconButton
          aria-label="סגירה"
          onClick={onClose}
          sx={{ position: "absolute", right: 12, top: 12 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <RelevantOpportunitiesForVolunteerList
          userId={userId}
          userName={userName}
          associationId={associationId}
          organizationId={organizationId}
          excludeOpportunityId={excludeOpportunityId}
          hasVolunteerCoordinates={hasVolunteerCoordinates}
          enabled={open}
        />
      </DialogContent>
    </Dialog>
  );
}
